/**
 * Global InstructorNav component. Up to the designers to decide if should live
 * as a top-nav, fixed side, menu-prompted, etc.
 *
 * Recommended to select a good one from Tailwind UI that matches the brand
 * and edit from there.
 * https://tailwindui.com/components/application-ui/headings/page-headings
 */
import React from 'react'
import { NavLink, useLocation } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useLoggedInUser } from '../../../resources/user/authService';
import { sendLogout } from '../../../resources/user/authStore';

const InstructorNav = () => {
  const loggedInUser = useLoggedInUser();

  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

    const handleLogout = async () => {
        await dispatch(sendLogout());
        dispatch({ type: 'LOGOUT' });
        localStorage.removeItem('user');
        history.replace("/user/login");
    }

  const navLinkClasses = "my-auto flex flex-row gap-2 hover:no-underline text-gray-400 align-center";
  const activeNavLinkClasses = "text-inherit";

  return (
    <header className="border-b border-solid shadow-sm bg-white">
      <nav className="py-2 px-6 flex flex-col md:flex-row justify-between items-center">
        <ul className="list-none p-0 flex flex-row gap-6 font-semibold">
          <li>
            <NavLink to="/instructor/courses" className={navLinkClasses} activeClassName={activeNavLinkClasses}>
              <i className="fa-sharp fa-regular fa-memo"></i>
              <p className={`text-inherit hidden sm:block`}>My Courses</p>
            </NavLink>
          </li>
        </ul>

        {!loggedInUser ?
          <ul className="list-none p-0 flex flex-row">
            <li><NavLink to={{ pathname: "/user/login", state: { from: location } }} className="p-2 block">Sign in</NavLink></li>
            <li><NavLink to={{ pathname: "/user/register", state: { from: location } }} className="p-2 block">Register</NavLink></li>
          </ul>
          :
          <ul className="list-none p-0 flex flex-col md:flex-row items-center text-xs sm:text-base">
            <li className='my-auto'>
                <p className="p-2 block">{loggedInUser.username}</p>
            </li>
            <li className='my-auto'>
                <button className="p-2 block" onClick={handleLogout}>
                    Logout
                </button>
            </li>
            <li className="my-auto">
              <div className="hidden md:inline-block  min-h-[1em] w-0.5 self-stretch bg-black opacity-50 dark:opacity-50 mr-2"/>
                <hr className="inline-block md:hidden min-w-[100px]"/>
            </li>
            <li className="my-auto relative items-start group">
              <a href="https://practice-quest.com/faq" target="_blank" rel="noreferrer"><i className="far fa-circle-question mr-2" /></a>
              <div className="absolute top-full right-0 flex flex-col items-start hidden mb-5 group-hover:flex">
                <div className="w-3 h-3 absolute -top-[4px] right-[8px] rotate-45 bg-black"></div>
                <span className="relative  rounded-md z-10 p-4 text-xs leading-none text-white whitespace-pre bg-black shadow-lg">Need help?</span>
              </div>
            </li>
          </ul>
        }
      </nav>
    </header>
  )
}

export default InstructorNav;
